enum keys {
  alertModalKey = "alertModalKey",
  adminDataKey = "adminDataKey",
  userDataKey = "userDataKey",
  loadingKey = "loadingKey",
  pathKey = "pathKey",
  infoDataKey = "infoDataKey",
  advDataKey = "advDataKey",
  memberSequnceKey = "memberSequnceKey",
}

export default keys;
